import { Component, Input, OnInit } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-average-learning-time',
    templateUrl: './average-learning-time.component.html',
    styleUrls: ['./average-learning-time.component.scss'],
})
export class AverageLearningTimeComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    avgLearningTime: string;

    @Input()
    horizontalView: boolean;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
